function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { combineLatest, of } from 'rxjs';
import { debounceTime, mergeMap, map } from 'rxjs/operators';
import { arrayPartition } from '../common/array-util';
import { assert } from '../common/assert';
import { firstGroupBy, secondGroupBy } from '../models/project-grouping';
import { getGroupId, NO_GROUP, stringToGroupId, groupingToContainer, isGroup, isVirtualFolder, projectGroupKeyToContainer, extractClient, keyToGrouping, hasSecondary, isInProjectGroup } from '../services/project-grouping';
import StoreService from './store-service';
import { itemFilter, defaultFilter } from '../services/item-list-filter';
import { ItemType, isContainerKey, ItemLock, LockType, LockLevel, LockPermissions } from '../models';
import Maybe from '../common/maybe';
function past(date) {
  return new Date().getTime() - date.getTime();
}
var updateDebounce = 2000;
var ItemStore = /*#__PURE__*/function (_StoreService) {
  // eslint-disable-next-line max-params
  function ItemStore(stores, containerStore, treeStore, itemService, documentService) {
    var _this;
    _classCallCheck(this, ItemStore);
    _this = _callSuper(this, ItemStore, [stores]);
    _this.containerStore = containerStore;
    _this.treeStore = treeStore;
    _this.itemService = itemService;
    _this.documentService = documentService;
    return _this;
  }

  /**
   * Updates the stored metadata for the requested item from the API.
   * Automatically notifies all observers of any changes
   *
   * @param key The item whose metadata needs to be updated
   * @param container If `key` is a Document, the parent container key is needed
   * @param bundleId Since some cases, particularly tree view, require updating a very large number of items at the same time, bundleId is used to keep track of which update calls are related. Bundled calls we be queued and throttled, and other non-bundled calls will get higher priority, as will newer bundled calls. Queued bundled calls may also be canceled by calling `cancelQueueForBundle` on any class that extends `Service`.
   */
  _inherits(ItemStore, _StoreService);
  return _createClass(ItemStore, [{
    key: "updateItem",
    value: (function () {
      var _updateItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(key, container, bundleId) {
        var isCurrent;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // We can't observe clients from here because we need the companyId.
              // In the future, we could add Company as a container type, but it seems unnecessary.
              assert(key.type !== ItemType.Client, 'ItemStore.observeItem called with client key. Use clientStore instead.', true, key);
              assert(container !== null && container !== void 0 ? container : key.type !== ItemType.Document, 'ItemStore.observeItem called with document but no container.', true, key);
              _context.next = 4;
              return this.recentlyUpdated(key);
            case 4:
              isCurrent = _context.sent;
              if (isCurrent) {
                _context.next = 14;
                break;
              }
              if (!container) {
                _context.next = 11;
                break;
              }
              _context.next = 9;
              return this.treeStore.updateChildren(container, {
                bundleId: bundleId
              });
            case 9:
              _context.next = 14;
              break;
            case 11:
              if (!isContainerKey(key)) {
                _context.next = 14;
                break;
              }
              _context.next = 14;
              return this.containerStore.update(key);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function updateItem(_x, _x2, _x3) {
        return _updateItem.apply(this, arguments);
      }
      return updateItem;
    }()
    /**
     * Returns observable for item but does *not* update item metadata in cache.
     *
     * @param key - item to watch
     */
    )
  }, {
    key: "observeItem",
    value: function observeItem(key) {
      if (isVirtualFolder(key)) {
        return of(projectGroupKeyToContainer(key));
      }
      return this.stores.items.observe(key);
    }
  }, {
    key: "observeItems",
    value: function observeItems(keys, filter) {
      var _this2 = this;
      // Given an empty array, `combineLatest` completes without emitting,
      // when given an empty array we will emit an empty array.
      if (!keys.length) {
        return of([]);
      }
      var items$ = keys.map(function (key) {
        return _this2.stores.items.observe(key);
      });
      return combineLatest(items$).pipe(map(function (items) {
        return items.filter(itemFilter(filter));
      }));
    }
  }, {
    key: "observeChildItems",
    value: function observeChildItems(key, filter) {
      filter = defaultFilter(filter);
      if (key.type === ItemType.Client || isVirtualFolder(key)) {
        return this.observeProjects(key, filter);
      }
      return this._observeChildItems(key, filter);
    }
  }, {
    key: "observeProjects",
    value: function observeProjects(key, filter) {
      var _this3 = this;
      var client = isVirtualFolder(key) ? extractClient(key) : key;
      var projects$ = this.observeFilteredProjects(client, key, filter);
      var groupBy = filter.grouping && isGroup(filter.grouping.groupBy) && filter.grouping.groupBy;
      if (groupBy) {
        var isClient = key.type === ItemType.Client;
        var groupingFromKey = isVirtualFolder(key) && keyToGrouping(key);
        var isTopLevelGroup = groupBy && hasSecondary(groupBy) && groupingFromKey ? !groupingFromKey.subGroupId : false;
        if (isClient || isTopLevelGroup) {
          var isSubGroup = hasSecondary(groupBy) && groupingFromKey && !!groupingFromKey.groupId;
          var childGroupBy = isSubGroup ? secondGroupBy[groupBy] : firstGroupBy[groupingFromKey ? groupingFromKey.groupBy : filter.grouping.groupBy];
          var superGroupId = groupingFromKey ? groupingFromKey.groupId : undefined;
          return projects$.pipe(map(function (projects) {
            return _this3.groupProjects(client, projects, childGroupBy, groupBy, superGroupId);
          }));
        }
      }
      return projects$;
    }
  }, {
    key: "observeFilteredProjects",
    value: function observeFilteredProjects(client, key, filter) {
      var projects$ = this._observeChildItems(client, filter);
      return projects$.pipe(map(function (projects) {
        if (isVirtualFolder(key)) {
          var grouping = keyToGrouping(key);
          return projects.filter(function (project) {
            return isInProjectGroup(project, grouping);
          });
        }
        return projects;
      }));
    }

    // eslint-disable-next-line max-params
  }, {
    key: "groupProjects",
    value: function groupProjects(parent, projects, childGroupBy, groupBy, superGroupId) {
      var _this4 = this;
      // Keeps track of which groups are locked by group ID
      var isLocked = {};
      var groupsAndProjects = arrayPartition(projects, function (item) {
        var id = String(getGroupId(childGroupBy, item));
        // If this or any previous item in this group was locked, the whole group is locked.
        isLocked[id] = isLocked[id] || !!item.lock;
        return id;
      });
      var groups = Object.keys(groupsAndProjects).filter(function (id) {
        return id !== NO_GROUP;
      });
      var groupContainers = groups.map(function (groupIdString) {
        var locked = !!isLocked[groupIdString];
        return _this4.groupToContainer(parent, groupIdString, childGroupBy, groupBy, locked, superGroupId);
      });
      var unGroupedProjects = groupsAndProjects[NO_GROUP];
      return [].concat(_toConsumableArray(groupContainers), _toConsumableArray(unGroupedProjects));
    }

    // eslint-disable-next-line max-params
  }, {
    key: "groupToContainer",
    value: function groupToContainer(parent, groupIdString, groupType, groupBy, locked, superGroupId) {
      var groupId = stringToGroupId(groupIdString, groupType);
      var grouping = {
        groupBy: groupBy,
        groupId: superGroupId !== null && superGroupId !== void 0 ? superGroupId : groupId,
        subGroupId: superGroupId ? groupId : undefined
      };
      return groupingToContainer(groupType, grouping, parent, locked);
    }
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(key) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.itemService.delete(key);
            case 2:
              _context2.next = 4;
              return this.removeFromStores(key);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _delete(_x4) {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
  }, {
    key: "trash",
    value: function () {
      var _trash = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(key) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.itemService.trash(key);
            case 2:
              _context3.next = 4;
              return this.removeFromStores(key);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function trash(_x5) {
        return _trash.apply(this, arguments);
      }
      return trash;
    }()
  }, {
    key: "unlock",
    value: function () {
      var _unlock = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(key) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.itemService.unlock(key);
            case 2:
              _context4.next = 4;
              return this.stores.items.update(key, function (maybeItem) {
                return maybeItem.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    lock: undefined
                  });
                });
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function unlock(_x6) {
        return _unlock.apply(this, arguments);
      }
      return unlock;
    }()
  }, {
    key: "updateAncestryFromParent",
    value: function () {
      var _updateAncestryFromParent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(key) {
        var _this5 = this;
        var maybeParent;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!isContainerKey(key)) {
                _context6.next = 4;
                break;
              }
              _context6.t0 = Maybe.just(key);
              _context6.next = 7;
              break;
            case 4:
              _context6.next = 6;
              return this.stores.parents.get(key);
            case 6:
              _context6.t0 = _context6.sent;
            case 7:
              maybeParent = _context6.t0;
              maybeParent.do(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(parent) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        return _context5.abrupt("return", _this5.treeStore.updateAncestry(parent));
                      case 1:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x8) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateAncestryFromParent(_x7) {
        return _updateAncestryFromParent.apply(this, arguments);
      }
      return updateAncestryFromParent;
    }()
  }, {
    key: "renameDocument",
    value: function () {
      var _renameDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(key, containerKey, name) {
        var maybeDocument, document, renamed;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.stores.items.get(key);
            case 2:
              maybeDocument = _context7.sent;
              if (!maybeDocument.hasValue) {
                _context7.next = 7;
                break;
              }
              _context7.t0 = maybeDocument.value;
              _context7.next = 10;
              break;
            case 7:
              _context7.next = 9;
              return this.documentService.get(key, containerKey);
            case 9:
              _context7.t0 = _context7.sent;
            case 10:
              document = _context7.t0;
              _context7.next = 13;
              return this.itemService.rename(document, name);
            case 13:
              renamed = _context7.sent;
              _context7.next = 16;
              return this.stores.items.put(key, renamed);
            case 16:
              return _context7.abrupt("return", renamed);
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function renameDocument(_x9, _x10, _x11) {
        return _renameDocument.apply(this, arguments);
      }
      return renameDocument;
    }()
  }, {
    key: "moveDocument",
    value: function () {
      var _moveDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(target, key) {
        var maybeDocument, document, updatedDocument;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.stores.items.get(key);
            case 2:
              maybeDocument = _context8.sent;
              if (!maybeDocument.hasValue) {
                _context8.next = 7;
                break;
              }
              _context8.t0 = maybeDocument.value;
              _context8.next = 10;
              break;
            case 7:
              _context8.next = 9;
              return this.documentService.get(key, key.parent);
            case 9:
              _context8.t0 = _context8.sent;
            case 10:
              document = _context8.t0;
              _context8.next = 13;
              return this.documentService.moveDocument(target, document);
            case 13:
              updatedDocument = _context8.sent;
              _context8.next = 16;
              return this.stores.items.put(key, updatedDocument);
            case 16:
              _context8.next = 18;
              return this.stores.parents.put(key, updatedDocument.parent);
            case 18:
              _context8.next = 20;
              return this.stores.children.update(updatedDocument.parent, function (maybeChildren) {
                return maybeChildren.map(function (children) {
                  children.push(updatedDocument);
                  return children;
                });
              });
            case 20:
              return _context8.abrupt("return", updatedDocument);
            case 21:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function moveDocument(_x12, _x13) {
        return _moveDocument.apply(this, arguments);
      }
      return moveDocument;
    }()
  }, {
    key: "moveDocuments",
    value: function () {
      var _moveDocuments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(target, keys) {
        var _this6 = this;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", Promise.all(keys.map(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(key) {
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        return _context9.abrupt("return", _this6.moveDocument(target, key));
                      case 1:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function (_x16) {
                  return _ref2.apply(this, arguments);
                };
              }())));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      function moveDocuments(_x14, _x15) {
        return _moveDocuments.apply(this, arguments);
      }
      return moveDocuments;
    }()
  }, {
    key: "copyDocument",
    value: function () {
      var _copyDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(doc, target) {
        var newDoc;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.documentService.copyDocument(doc, target);
            case 2:
              newDoc = _context11.sent;
              _context11.next = 5;
              return this.stores.items.put(newDoc, newDoc);
            case 5:
              _context11.next = 7;
              return this.stores.parents.put(newDoc, newDoc.parent);
            case 7:
              _context11.next = 9;
              return this.stores.children.update(newDoc.parent, function (maybeChildren) {
                return maybeChildren.map(function (children) {
                  children.push(newDoc);
                  return children;
                });
              });
            case 9:
              return _context11.abrupt("return", newDoc);
            case 10:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function copyDocument(_x17, _x18) {
        return _copyDocument.apply(this, arguments);
      }
      return copyDocument;
    }()
  }, {
    key: "addTemporaryLock",
    value: function () {
      var _addTemporaryLock = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(item, user) {
        var itemLock;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (!(item.lock && item.lock.type !== LockType.None)) {
                _context12.next = 2;
                break;
              }
              return _context12.abrupt("return", item);
            case 2:
              // create a fake lock to show a lock on the UI until a real lock is set
              itemLock = new ItemLock(LockType.Read, LockLevel.Master, new LockPermissions(false, true, false, false, false, true, true, false), user, new Date(), new Map());
              item = _objectSpread(_objectSpread({}, item), {}, {
                lock: itemLock
              });
              _context12.next = 6;
              return this.stores.items.put({
                id: item.id,
                type: item.type
              }, item);
            case 6:
              return _context12.abrupt("return", item);
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function addTemporaryLock(_x19, _x20) {
        return _addTemporaryLock.apply(this, arguments);
      }
      return addTemporaryLock;
    }()
  }, {
    key: "_observeChildItems",
    value: function _observeChildItems(key, filter) {
      var _this7 = this;
      return this.treeStore.observeChildrenKeys(key, filter.includeFiles, filter.includeFolders).pipe(mergeMap(function (childKeys) {
        return _this7.observeItems(childKeys, filter);
      }), debounceTime(100));
    }
  }, {
    key: "recentlyUpdated",
    value: function () {
      var _recentlyUpdated = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(key) {
        var lastUpdated;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.stores.items.getLastModified(key);
            case 2:
              lastUpdated = _context13.sent;
              return _context13.abrupt("return", lastUpdated.hasValue && past(lastUpdated.value) < updateDebounce);
            case 4:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function recentlyUpdated(_x21) {
        return _recentlyUpdated.apply(this, arguments);
      }
      return recentlyUpdated;
    }()
  }]);
}(StoreService);
export { ItemStore as default };
